import moment from 'moment'

export const KANBAN_FILTERS_STORAGE_KEY = 'kanbanFiltersSearch'

export const getDefaultKanbanFilters = () => ({
    startDate: moment().subtract(1, 'month').startOf('day'),
    endDate: moment().add(3, 'month').endOf('day'),
    responsible: null,
    description: null,
    numberOt: null,
    taskType: 'all',
})

export const parseKanbanFiltersFromSearchParams = (searchParams) => {
    const defaults = getDefaultKanbanFilters()
    const startDate = searchParams.get('startDate')
    const endDate = searchParams.get('endDate')
    const responsibleId = searchParams.get('responsible')
    const description = searchParams.get('description')
    const numberOt = searchParams.get('numberOt')
    const taskType = searchParams.get('taskType')

    return {
        startDate: startDate ? moment(startDate, 'YYYY-MM-DD') : defaults.startDate,
        endDate: endDate ? moment(endDate, 'YYYY-MM-DD') : defaults.endDate,
        responsible: responsibleId ? { id: Number(responsibleId) } : null,
        description: description || null,
        numberOt: numberOt || null,
        taskType: taskType || defaults.taskType,
    }
}

export const kanbanFiltersToSearchParams = (filters, viewTab = 'kanban') => {
    const params = new URLSearchParams()

    if (viewTab && viewTab !== 'kanban') {
        params.set('view', viewTab)
    }

    if (filters.startDate) {
        params.set('startDate', filters.startDate.format('YYYY-MM-DD'))
    }
    if (filters.endDate) {
        params.set('endDate', filters.endDate.format('YYYY-MM-DD'))
    }
    if (filters.responsible?.id) {
        params.set('responsible', String(filters.responsible.id))
    }
    if (filters.description) {
        params.set('description', filters.description)
    }
    if (filters.numberOt) {
        params.set('numberOt', filters.numberOt)
    }
    if (filters.taskType && filters.taskType !== 'all') {
        params.set('taskType', filters.taskType)
    }

    return params
}

export const buildKanbanTasksRequest = (filters) => ({
    startDate: filters.startDate,
    endDate: filters.endDate,
    responsible: filters.responsible?.id ?? null,
    description: filters.description || null,
    numberOt: filters.numberOt || null,
    taskType: filters.taskType && filters.taskType !== 'all' ? filters.taskType : null,
})

export const hasActiveKanbanFilters = (searchParams) => {
    const filterKeys = ['responsible', 'description', 'numberOt', 'taskType']
    return filterKeys.some((key) => {
        const value = searchParams.get(key)
        return value !== null && value !== ''
    })
}

export const getKanbanReturnPath = () => {
    const stored = sessionStorage.getItem(KANBAN_FILTERS_STORAGE_KEY)
    return stored ? `/task/wo?${stored}` : '/task/wo'
}

export const saveKanbanFiltersToStorage = (searchParams) => {
    const value = searchParams.toString()
    if (value) {
        sessionStorage.setItem(KANBAN_FILTERS_STORAGE_KEY, value)
    } else {
        sessionStorage.removeItem(KANBAN_FILTERS_STORAGE_KEY)
    }
}
